import { render, staticRenderFns } from "./BlindRepliesPage.vue?vue&type=template&id=74cbc2f4&scoped=true"
import script from "./BlindRepliesPage.vue?vue&type=script&lang=js"
export * from "./BlindRepliesPage.vue?vue&type=script&lang=js"
import style0 from "./BlindRepliesPage.vue?vue&type=style&index=0&id=74cbc2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cbc2f4",
  null
  
)

export default component.exports